import {CanvasModule, CanvasModuleType} from '@pdf-tools/four-heights-pdf-web-viewer/es6/modules/CanvasModule';
import { CustomAddStampAnnotationLayer } from './CustomAddStampAnnotationLayer';


export class CustomStampAnnotationModule extends CanvasModule {
  public toolbarElement: HTMLElement | null = null;


  static moduleInfo = {
    name: 'StampAnnotationModule',
    moduleType: CanvasModuleType.Tool,
    requiredFeatures: {
      annotate: true,
      fillFormFields: false,
    },
    translationKey: 'annotStamp.add',
    icon: 'stamp',
  };

  constructor() {
    super();
    // @ts-ignore
    this.annotationbarElement = null;
    this.toolbarElement = null;
    this.name = CustomStampAnnotationModule.moduleInfo.name;
    this.activate = this.activate.bind(this);
  }
  onRegister() {
    this.toolbarElement = document.createElement('div');
    return {
      toolbar: this.toolbarElement,
    };
  }
  activate() {
    if (!this.canvasLayers['add']) {
      this.createCanvasLayer('add', CustomAddStampAnnotationLayer);
    }
    else {
      this.removeCanvasLayer('add');
    }
  }
}



